// extracted by mini-css-extract-plugin
var _1 = "fJPLe__header";
var _2 = "fJPLe__title";
var _3 = "fJPLe__toggleFriends";
export { _1 as "header", _2 as "title", _3 as "toggleFriends" }
